import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import makeStyles from '@material-ui/core/styles/makeStyles';
import MuiButton from '@material-ui/core/Button';

const useStyles = makeStyles({
  root: {
    fontSize: '0.75rem'
  }
});

const Button = ({
  onClick,
  disabled = false,
  size = 'medium',
  endIcon,
  children,
  classes = {}
}) => {
  const localClasses = useStyles();
  const allClasses = {
    ...localClasses,
    ...classes,
    root: cx(localClasses.root, classes.root)
  };

  return (
    <MuiButton
      variant="outlined"
      color="primary"
      onClick={onClick}
      disabled={disabled}
      size={size}
      classes={allClasses}
      endIcon={endIcon}
    >
      {children}
    </MuiButton>
  );
};

Button.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  size: PropTypes.string,
  endIcon: PropTypes.node,
  children: PropTypes.object.isRequired,
  classes: PropTypes.object
};

export default Button;
